import { getCookieContent, getCookieValue } from './cookies';

export default function getStoreId(): string {
  const visitorCookie = getCookieContent('KmxVisitor_0');
  const visitorStoreId = visitorCookie
    ? getCookieValue(visitorCookie, 'StoreId')
    : '';
  if (visitorStoreId) {
    return visitorStoreId;
  }
  const storeCookie = getCookieContent('KmxStore');
  return storeCookie ? getCookieValue(storeCookie, 'StoreId') : '';
}
